import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('click', function () {
      this.querySelector('input').checked = !this.querySelector('input').checked;
    });
  }
}
